<table class="table table-hover">
  <thead>
    <tr>
      <th translate>{{ 'dashboardScope.dashboard.server-process.ID' | transloco }}</th>
      <th translate>{{ 'dashboardScope.dashboard.server-process.Name' | transloco }}</th>
      <th translate>{{ 'dashboardScope.dashboard.server-process.CPU' | transloco }}</th>
      <th translate>{{ 'dashboardScope.dashboard.server-process.Memory' | transloco }}</th>
      <th translate>{{ 'dashboardScope.dashboard.server-process.Threads' | transloco }}</th>
      <th translate>{{ 'dashboardScope.dashboard.server-process.Read' | transloco }}</th>
      <th translate>{{ 'dashboardScope.dashboard.server-process.Write' | transloco }}</th>
      <th translate>{{ 'dashboardScope.dashboard.server-process.Time' | transloco }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let process of processes$ | async">
      <td>{{ process.processId }}</td>
      <td>{{ process.name }}</td>
      <td>{{ process.cpuUsagePercentage / 100 | percent: '1.2':translateService.getActiveLang() }}</td>
      <td>{{ process.memUsagePercentage / 100 | percent: '1.2':translateService.getActiveLang() }}</td>
      <td>{{ process.threadCount }}</td>
      <td>{{ process.diskReadBytes | fileSize }}</td>
      <td>{{ process.diskWriteBytes | fileSize }}</td>
      <td>{{ process.timeUptime | duration }}</td>
    </tr>
  </tbody>
</table>

<!-- https://angular.io/api/common/PercentPipe -->
